import HttpBEService from './http-backend-service'
import {AuditEventType, BE_API} from '../data/constants'
import { ViewbillResponseOrderDetailItems } from './types/view-bill-service.types'
import { ApiRequest } from 'interfaces/api-request.interface'
import { LoggerMetaData } from 'interfaces/logger.interface'
class ViewBillService extends HttpBEService{

    async getBill(mode:string, page:string, loggerMetaData: LoggerMetaData, signal?:AbortSignal){

        loggerMetaData.mode = mode;
        loggerMetaData.page = page;
        
        const apiRequest: ApiRequest = {
            method: 'get',
            endpoint: BE_API.BILL,
            eventType: AuditEventType.GET_BILL,
            signal
        }
        const res = await this.doFetch(apiRequest,loggerMetaData);

        if(res.error) return {error: res.error, data: null}
        return {error: null, data: res.data.data}
    }

    initialViewBillResponse(items:ViewbillResponseOrderDetailItems[]){
        return items.map((item) =>{
            let subItems = item.customisations;
            if(Array.isArray(subItems)){
                subItems = subItems.map((subItems)=>{
                    return {...subItems,open:false}
                })
            }
            if(subItems) return {...item,custom:subItems,open:false}
            return {...item,open:false}
        })
    }

    async initiatePayment(data:any, loggerMetaData: LoggerMetaData, signal?:AbortSignal){
        const apiRequest: ApiRequest = {
            method: 'post',
            endpoint: BE_API.INITIATE_PAYMENT,
            eventType: AuditEventType.INITIATE_PAYMENT,
            signal,
            body: data
        }
        const res = await this.doFetch(apiRequest,loggerMetaData);

        if(res.error) return {error: res.error, data: null}

        return {error: null, data: res.data.data}
    }

    async getSplitInfoData(loggerMetaData: LoggerMetaData, signal?:AbortSignal) {
        const apiRequest: ApiRequest = {
            method: 'get',
            endpoint: BE_API.SPLIT_INFO,
            eventType: AuditEventType.GET_BILL_POLL,
            signal
        }
        const res = await this.doFetch(apiRequest,loggerMetaData);

        if(res.error) return {error: res.error, data: null}

        return {error: null, data: res.data.data}
    }

    async calculateFee(paymentType: string, amount: number, loggerMetaData: LoggerMetaData, signal?: AbortSignal, isReverse?: boolean, grandTotal?: number) {
        let endpoint = `${BE_API.CALCULATE_FEE}?paymentType=${encodeURIComponent(paymentType)}&amount=${amount}`;
        if (isReverse) endpoint += '&isReverse=1';
        // FIXED_AMOUNT proportional allocation: Split PF = (amount / grandTotal) * fixedFee.
        // Ignored server-side for PERCENTAGE; omit for non-split (fraction 1 → full flat fee).
        if (grandTotal !== undefined && grandTotal > 0) endpoint += `&grandTotal=${grandTotal}`;
        const apiRequest: ApiRequest = {
            method: 'get',
            endpoint,
            eventType: AuditEventType.CALCULATE_FEE,
            signal
        }
        const res = await this.doFetch(apiRequest, loggerMetaData)
        if (res.error) return { error: res.error, data: null }
        return { error: null, data: res.data.data }
    }
}


export default new ViewBillService();